import type { UrlOpenMethod } from '../types/ChatWindow';

enum EVENT_TYPES {
  UPDATE_WINDOW_TYPE = 'UPDATE_WINDOW_TYPE',
  NAVIGATE_TO_URL = 'NAVIGATE_TO_URL',
  SEND_CONSOLE_MESSAGE = 'SEND_CONSOLE_MESSAGE',
  LOCATION_REQUEST = 'LOCATION_REQUEST',
  RESTART_REQUEST = 'RESTART_REQUEST',
}

export const sendUpdateWindowType = (windowType: string) => {
  window.parent.postMessage(
    { eventType: EVENT_TYPES.UPDATE_WINDOW_TYPE, payload: { windowType } },
    '*',
  );
};

export const sendNavigateToUrl = (url: string, openMethod?: UrlOpenMethod) => {
  window.parent.postMessage(
    { eventType: EVENT_TYPES.NAVIGATE_TO_URL, payload: { url, openMethod } },
    '*',
  );
};

export const sendLocationRequest = () => {
  window.parent.postMessage({ eventType: EVENT_TYPES.LOCATION_REQUEST }, '*');
};

export const sendLogMessage = (message: string, messageType: string) => {
  window.parent.postMessage(
    {
      eventType: EVENT_TYPES.SEND_CONSOLE_MESSAGE,
      payload: { message, messageType },
    },
    '*',
  );
};

export const sendRestartRequest = () => {
  window.parent.postMessage({ eventType: EVENT_TYPES.RESTART_REQUEST }, '*');
};
